// extracted by mini-css-extract-plugin
export default {"splashScreen":"SplashScreen_splashScreen__AysbC","splashContent":"SplashScreen_splashContent__+N3e8","Logo":"SplashScreen_Logo__5wW-x","Welcome":"SplashScreen_Welcome__Hj-Zz"};